import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../shared/commons/services/user.service';
import { ToastService } from '../../../shared/commons/toast/toast-service';
import { ConfirmDialogService } from '../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service';
import { CommentationDto } from '../../../../generated-model/model';
import { CommentationRest } from '../../../service/CommentationRest';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-feedback-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './feedback-modal.component.html',
  styleUrl: './feedback-modal.component.scss'
})
export class FeedbackModalComponent {
  public activeModal = inject(NgbActiveModal);
  private userDataService = inject(UserService);
  toastService = inject(ToastService);
  confirmService = inject(ConfirmDialogService);
  commentationRest = inject(CommentationRest);
  commentationDto: CommentationDto ={}

  submitting = false;


  sentForm() {
    this.confirmService.open({content: 'ยืนยันการส่งแบบสอบถาม'}).pipe(filter(e => !!e))
      .subscribe(e => {
        this.submitting = true;

        this.commentationRest.save(this.commentationDto).subscribe({
          next: (value) => {
            this.toastService.showSuccess('ส่งแบบสอบถามสำเร็จ');
            this.activeModal.close(value);
          },
          error: (err) => {
            this.toastService.showDangerWithMessage('เกิดข้อผิดพลาดในการส่งแบบสอบถาม');
            console.error(err);
            this.submitting = false;
          },
          complete: () => {
            this.submitting = false;
          }
        });
      });
  }
}
